module.exports = __webpack_public_path__ + "static/media/playstore-6d.5bd91ffe.png";